<template>
    <v-col class="px-0" cols="12" id="scheme-switcher" align-items="center">
        <v-select v-if="listing.availableSchemes && listing.availableSchemes.length > 0"
            id="scheme-switcher"
            v-model="selection"
            variant="solo"
            :items="items"
            item-title="text"
            item-value="value"
            color="primary"
            @change="changed">
        </v-select>
    </v-col>
</template>

<script>
    import {has} from "lodash";

    export default {
        name: 'SchemeSwitcher',
        props: {
            listing: {
                required: true
            }
        },
        data(){
            return {
                selection: {}
            }
        },
        computed: {
            items(){
                if (!this.listing.availableSchemes?.length) {
                    return [];
                }

                const items = this.listing.availableSchemes.map(listing => {
                    const listingSlug = listing.custom_slug || listing.slug;
                    return {
                        text: listing.scheme_group.name,
                        value: listingSlug
                    };
                });

                const listingSlug = this.listing.widgetSiteSettings?.customSlug || this.listing.slug;
                items.unshift({
                    text: this.listing.schemeGroup.name,
                    value: listingSlug
                });

                this.selection = items[0];
                return items;
            }
        },
        methods: {
            changed(value){
                if(value != this.selection.value){
                    window.location = value;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '~vuetify/src/styles/styles.sass';

    #scheme-switcher{
        .v-input{
            margin-top: 8px;
            padding-top: 15px;

            &__slot{
                padding: 9px 10px;
                border-radius: 5px;
                border: 1px solid var(--v-primary-base);

                &:before{
                    display: none;
                }
            }

            &.v-select{
                .v-select__selection{
                    color: var(--v-primary-base);
                }

                .v-icon.mdi-menu-down{
                    &:before{
                        content: '\f0140' !important;
                        color: var(--v-primary-base);
                    }
                }
            }

            @media #{map-get($display-breakpoints, 'sm-and-down')}{
                margin-top: 0px;
                padding-top: 0px;
            }
        }

        @media #{map-get($display-breakpoints, 'sm-and-down')}{
            max-height: 60px;
        }
    }

    #listing-header{
        #scheme-switcher{
            @media #{map-get($display-breakpoints, 'sm-and-down')}{
                margin-top: -30px;
                max-height: 50px;
            }
        }
    }
</style>
